// 权益等级
import api from '@/api/levelEquity'

export default {
  data() {
    return {
      equityPartnerList: [],
      equityPopupInfo: {},
    }
  },

  methods: {
    // 全局弹窗初始化
    async globalDialogInit() {
      try {
        await this.isShowLevelEquityPopup()
        const { popupWindow, seasonId } = this.equityPopupInfo || {}
        if (!popupWindow) {
          return this.showMessage()
        }

        await this.getEquityPartnerList(seasonId)
        this.showLevelEquityPopup()
      } catch (err) {
        this.showMessage()
      }
    },

    // 判断赛季弹窗是否弹出
    async isShowLevelEquityPopup() {
      try {
        const res = await api.isShowLevelEquityPopup()
        console.log('isShowLevelEquityPopup', res)
        this.equityPopupInfo = res || {}
      } catch (err) {
        this.$addOwlError({
          name: `【等级权益全局弹窗】获取赛季弹窗是否弹出失败_${err.message}`,
          msg: { err },
        })
      }
    },

    // 获取有权限且上个赛季和当前赛季有权益周期的商
    async getEquityPartnerList(seasonId) {
      try {
        const params = { seasonId }
        const res = await api.getEquityPartnerList(params)
        console.log('getEquityPartnerList', res.cooperateDTOList)
        this.equityPartnerList = res.cooperateDTOList || []
      } catch (err) {
        this.$addOwlError({
          name: `【等级权益全局弹窗】获取合作商列表失败_${err.message}`,
          msg: { err },
        })
      }
    },

    // 展示等级权益弹窗
    showLevelEquityPopup() {
      const { supplierCode } = this.equityPartnerList[0] || {}
      const { seasonName, seasonId } = this.equityPopupInfo || {}
      this.$mtd
        .confirm({
          title: '新权益周期开启',
          message: `${seasonName}已开启，期待您解锁更多优质权益`,
          width: '430px',
          closable: false,
          showCancelButton: false,
          okButtonText: supplierCode ? '上一周期回顾' : '查看详情',
          onOk: () => {
            if (supplierCode) {
              setTimeout(() => {
                this.$refs.LevelEquityDialog && this.$refs.LevelEquityDialog.show(seasonId, 'prev')
              })
            } else {
              this.handleUpdateFlag(seasonId, supplierCode)
              if (this.$route.path !== '/level/equity') {
                this.$router.push('/level/equity')
              }
            }
          },
        })
        .catch(() => {})
    },

    handleUpdateFlag(seasonId, supplierCode) {
      const params = {
        seasonId,
        supplierCode,
        update: true,
      }
      api
        .getCurrentSeasonInfo(params)
        .then(() => {})
        .catch(err => {
          this.$addOwlError({
            name: `【等级权益全局弹窗】查看详情-更新标记失败_${err.message}`,
            msg: { params, err },
          })
        })
    },
  },
}
